import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input
} from "reactstrap";
import Webcam from "react-webcam";
import axios from "axios";
import TooltipItem from "../../common/TooltipItem";
import isEmpty from "lodash";
import Hotkeys from "react-hot-keys";

class ImageCaptures extends Component {
  setRef = webcam => {
    this.webcam = webcam;
  };

  constructor(props) {
    super(props);
    this.state = {
      constraints: {
        video: {
          width: 850,
          height: 600
        }
      },
      imageLabels: [
        {
          imageLabel: "Prescription Image",
          imageType: "prescriptionImage"
        },
        {
          imageLabel: "Label Image",
          imageType: "labelImage"
        },
        {
          imageLabel: "Pill Image",
          imageType: "pillImage"
        },
        {
          imageLabel: "Rx Bottle Image",
          imageType: "rxbottle"
        }
      ],
      prescriptionImages: [],
      activeImage: "",
      cameraActive: false,
      ndcImage: "",
      imageLabel: "Additional",
      imageCounter: 1,
      modal: false,
      previewModal: false,
      previewImage: "",
      nextLabel: "",
      toCapture: false,
      enableSubmit: false,
      setHotKeys: false
    };
    this.topressKey = this.topressKey.bind(this);
    this.handleStartClick = this.handleStartClick.bind(this);
    this.activateCamera = this.activateCamera.bind(this);
    this.onChange = this.onChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.togglePreview = this.togglePreview.bind(this);
    this.close = this.close.bind(this);
  }

  UNSAFE_componentWillMount() {
    let ndcImage;
    const imageLabels = this.state.imageLabels;
    //console.log("==========kEY PRESSED C============"+this.props.setHotKeys)
    //console.log("===========IUmages Size-===========" + imageLabels.length);
    this.props.draft.prescriptionImageUrls.forEach(images => {
      if (images.imageType === "ndcPillImage")
        ndcImage = `https://www.telerx.io${images.imageUrl}`;

      // console.log(ndcImage)
      this.setState({ ndcImage: ndcImage });
      if (images.imageType === "prescriptionImage") {
        imageLabels[0].imageSrc = images.imageUrl;
        // console.log("prescriptionImate   "+imageLabels)
      }

      if (images.imageType === "labelImage") {
        imageLabels[1].imageSrc = images.imageUrl;
        // console.log("labelImage  "+imageLabels)
      }
      if (images.imageType === "pillImage") {
        imageLabels[2].imageSrc = images.imageUrl;
        // console.log(imageLabels)
      }
      if (images.imageType === "rxbottle")
        imageLabels[3].imageSrc = images.imageUrl;
    });
    if (this.props.activeImage !== "") {
      //console.log("=====================Next Props=============="+this.props.imageLabels.length);
      this.setState({
        ...this.state,
        activeImage: this.props.activeImage,
        cameraActive: this.props.cameraActive,
        imageLabels: this.props.imageLabels,
        setHotKeys: true
      });
    } else {
      this.setState({
        ...this.state,
        activeImage: this.props.activeImage,
        cameraActive: this.props.cameraActive,
        imageLabels: this.props.imageLabels,
        setHotKeys: false
      });
    }
    // this.setState({
    //     ...this.state.imageLabels,
    //     imageLabels: imageLabels
    // });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    //console.log("==========kEY PRESSED C============"+this.state.setHotKeys)
    if (nextProps.activeImage !== "") {
      //console.log("=====================Next Props=============="+nextProps.imageLabels.length);
      this.setState({
        ...this.state,
        activeImage: nextProps.activeImage,
        cameraActive: nextProps.cameraActive,
        imageLabels: nextProps.imageLabels,
        setHotKeys: true
      });
    } else {
      this.setState({
        ...this.state,
        activeImage: nextProps.activeImage,
        cameraActive: nextProps.cameraActive,
        imageLabels: nextProps.imageLabels,
        setHotKeys: false
      });
    }
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }
  togglePreview(imgCurrent) {
    this.setState({
      previewImage: imgCurrent,
      previewModal: !this.state.previewModal,
      cameraActive: false
    });
  }

  handleStartClick = () => {
    this.props.handler(false);

    const imageBase = "https://tpms-prescription-images.s3.amazonaws.com/";
    const imageSrc = this.webcam.getScreenshot();
    this.setState({ setHotKeys: false });

    let uploadImage;
    const imageLabels = this.state.imageLabels;
    const index = imageLabels.findIndex(
      x => x.imageLabel === this.state.activeImage
    );
    imageLabels[index].imageSrc = imageSrc;
    if (imageSrc !== null) {
      // this.setState({cameraActive: false});
      let contentType = imageSrc.split(";")[0];
      let byteCharacters = atob(
        imageSrc.replace(/^data:image\/(jpeg);base64,/, "")
      );
      let byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], { type: contentType });
      let fileName = this.getUploadImageName();
      //console.log("================File Name==================" + fileName);
      let filePrefix = this.getUploadImagePrefix();
      let uploadedImgUrl = imageBase + filePrefix + "/" + fileName;
      axios
        .post(
          "https://280sdpcj87.execute-api.us-east-1.amazonaws.com/dev/requestUploadURL",
          {
            name: fileName,
            type: contentType,
            Prefix: filePrefix + "/"
          }
        )
        .then(data => {
          uploadImage = JSON.parse(JSON.stringify(data));
          axios
            .put(uploadImage.data.uploadURL, blob, {
              headers: {
                "Content-Type": "data:image/jpeg"
              },
              transformRequest: [
                (data, headers) => {
                  delete headers.common.Authorization;
                  return data;
                }
              ]
            })
            .then(() => {
              const imageLabels = this.state.imageLabels;
              const index = imageLabels.findIndex(
                x => x.imageLabel === this.state.activeImage
              );
              const currentImage = imageLabels[index];
              this.pushImage(
                currentImage.imageLabel,
                currentImage.imageType,
                uploadedImgUrl
              );
            })
            .catch(err => {
              // console.log(err.message); // SHOW ERRORS IF ANY.
            });

          this.setState({
            ...this.state.imageLabels,
            imageLabels: imageLabels
          });
        });
    } else {
    }
  };

  pushImage = (imageTitle, imageName, imageUrl) => {
    //console.log("===========Push image title==============" + imageTitle);
    let prescriptionImages = this.props.draft;
    let imageUrs = this.state.imageLabels;
    let imageAdded = false;
    for (let i = 0; i < imageUrs.length; i++) {
      imageAdded = false;
      let image = imageUrs[i];
      if (image.imageType === imageName) {
        imageUrs[i].imageUrl = imageUrl;
        imageUrs[i].imageTitle = imageTitle;
        imageAdded = true;
        break;
      }
    }

    if (imageAdded === false) {
      let newImage = {
        imageTitle: imageTitle,
        imageType: imageName,
        imageUrl: imageUrl
      };
      imageUrs.push(newImage);
    }
    imageUrs.map(img => {
      //console.log("===========Push image title==============" + JSON.stringify(img));
      // if (image.imageType === imageName) {
      //     imageUrs[i].imageUrl = imageUrl;
      //     imageUrs[i].imageTitle = imageTitle;
      //     imageAdded = true;
      //     break;
      // }
    });
    prescriptionImages.prescriptionImageUrls = imageUrs;
    prescriptionImages.rxInfo.rxStatus = "Pending";

    //console.log(">>>about to do pushImage ...");
    this.props.onCapture(prescriptionImages);
    // console.log("+===========Props==============="+JSON.stringify(prescriptionImag
    // es));

    // if (this.state.toCapture) {
    //     this.activateCamera(this.state.nextLabel);
    // }
    this.props.handler(true);
  };

  getUploadImageName = () => {
    let uploadImgName;
    uploadImgName = this.props.draft.rxInfo.prescriptionNumber + "_";
    if (this.state.activeImage === "Label Image") {
      uploadImgName += "labelImage.jpg";
    } else if (this.state.activeImage === "Prescription Image") {
      uploadImgName += "prescriptionImage.jpg";
    } else if (this.state.activeImage === "Pill Image") {
      uploadImgName += "pillImage.jpg";
    } else if (this.state.activeImage === "Rx Bottle Image") {
      //console.log("=============rx bottle============"+uploadImgName)
      uploadImgName += "rxbottle.jpg";
      //console.log("=============rx bottle============"+uploadImgName)
    } else {
      uploadImgName +=
        new Date().getTime() + "_" + this.state.activeImage + ".jpg";
    }
    return uploadImgName;
  };

  getUploadImagePrefix = () => {
    let orgID;
    localStorage.orgID ? (orgID = localStorage.orgID) : (orgID = 1);
    let branch;
    localStorage.branch ? (branch = localStorage.branch) : (branch = "Chama");
    const branchName = branch,
      orgId = orgID;
    let uploadImgPrefix;
    uploadImgPrefix =
      orgId +
      "/" +
      branchName +
      "/" +
      this.props.draft.rxInfo.prescriptionNumber;
    return uploadImgPrefix;
  };

  activateCamera = label => {
    //console.log("=================Activate Next Label===================="+label);

    this.setState({ activeImage: label, cameraActive: true, setHotKeys: true });
    // console.log("=============Activate
    // Image=============="+this.setState.activeImage);
  };

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value + 1
    });
    this.confirm();
    //console.log("============Image Labels==============="+e.target.value);
  };

  onAdditional = () => {
    this.setState({
      imageCounter: this.state.imageCounter + 1
    });
    this.confirm();
    // console.log("============Image
    // Labels==============="+this.state.imageCounter);
  };

  confirm = () => {
    const imageLabels = this.state.imageLabels;
    const imgCounter = this.state.imageCounter;
    // console.log("============Image
    // Labels==============="+JSON.stringify(imageLabels));
    let image = {};
    image.imageType = this.state.imageLabel.replace(
      /(?:^\w|[A-Z]|\b\w|\s+)/g,
      function(match, index) {
        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
      }
    );
    //image.imageLabel = this.state.imageLabel;
    var re = /(\b[a-z](?!\b))/g;
    image.imageLabel =
      this.state.imageLabel.replace(re, function(x) {
        return x.toUpperCase();
      }) +
      "_" +
      imgCounter;
    imageLabels.push(image);
    this.setState({
      ...this.state.imageLabels,
      imageLabels: imageLabels
    });
    //this.toggleModal();
  };

  close = () => {
    this.setState({ imageLabel: "" });
    this.toggleModal();
  };

  render() {
    const {
      activeImage,
      cameraActive,
      constraints,
      ndcImage,
      imageLabel,
      imageLabels
    } = this.state;
    let imageLabelsArr;
    imageLabelsArr = imageLabels.map((label, index) => (
      <Col lg="2" md="3" className="card-block">
        <Card>
          {isEmpty(label.imageSrc) && (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={() => this.activateCamera(label.imageLabel)}
              key={index}
            >
              <div className="top">
                <i className="fas fa-camera-retro fa-3x" />
              </div>
              <div className="centered">
                <span>{label.imageLabel}</span>
              </div>
            </div>
          )}
          <img
            id={label.imageType}
            src={label.imageSrc}
            style={{
              zIndex: "1"
            }}
            alt=""
          />
          <TooltipItem
            tooltipText={label.imageLabel}
            target={label.imageType}
            placement="top"
          />{" "}
          {label.imageSrc ? (
            <CardFooter>
              <div>
                <div
                  style={{
                    cursor: "pointer"
                  }}
                >
                  <i
                    className="d-inline-block fas fa-pencil-alt float-left"
                    onClick={() => this.activateCamera(label.imageLabel)}
                    key={index}
                  />
                </div>

                <div
                  style={{
                    cursor: "pointer"
                  }}
                >
                  <i
                    className="d-inline-block fas fa-eye float-right"
                    onClick={() => this.togglePreview(label.imageSrc)}
                    key={index}
                  />
                </div>
              </div>
            </CardFooter>
          ) : (
            " "
          )}
        </Card>
      </Col>
    ));

    let toPress;
    if (this.state.cameraActive) {
      toPress = (
        <Hotkeys keyName="c" onKeyUp={this.topressKey}>
          <i className="fas fa-camera" onClick={this.handleStartClick} />
        </Hotkeys>
      );
    } else {
      toPress = <div></div>;
    }

    return (
      <Container>
        <div className="container horizontal-scrollable">
          {/* <Row
                        className="flex-row flex-nowrap"
                        style={{
                        height: 150
                    }}>
                        <Col lg="2" md="3">
                            <div className="form-group">
                                <img id="img1" src={this.state.ndcImage} alt=""/>
                                <TooltipItem tooltipText="NDC Image" target="img1" placement="top"/>
                            </div>
                        </Col>
                        {imageLabelsArr}
                        <Col lg="2" md="3">
                            <div
                                name="imageCounter"
                                onClick={this.onAdditional}
                                style={{
                                cursor: "pointer"
                            }}
                                className="card-block">
                                <div className="top">
                                    <i className="d-inline-block fas fa-plus fa-3x"/>
                                </div>
                                <div className="centered">
                                    <span>Add image</span>
                                </div>
                            </div>
                        </Col>
                    </Row> */}
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
          <ModalBody>
            <Input
              type="text"
              name="imageLabel"
              value={imageLabel}
              placeholder="Image Label"
              onChange={this.onChange}
              autoFocus={false}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.confirm}>
              Confirm
            </Button>
            <Button color="secondary" onClick={this.close}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
        <Card
          className="mx-auto mt-2"
          style={{
            height: "600px",
            width: "850px",
            border: "1px solid #000"
          }}
        >
          {cameraActive && (
            <div>
              {/* <GlobalHotKeys keyMap={keyMap} handlers={this.handlers}/> */}
              <div
                className=""
                style={{
                  position: "absolute",
                  textAlign: "center",
                  zIndex: "999",
                  color: "white",
                  width: "100%",
                  backgroundColor: "#000",
                  opacity: "0.3",
                  padding: "5px 0",
                  fontWeight: "bold",
                  borderRadius: "0.25rem"
                }}
              >
                Capture {activeImage}
              </div>
              <Webcam
                audio={false}
                videoConstraints={constraints}
                screenshotFormat="image/jpeg"
                ref={this.setRef}
                height={600}
                width={850}
              />
              <div
                style={{
                  position: "absolute",
                  top: "92.5%",
                  width: "100%",
                  textAlign: "center",
                  fontSize: "2rem",
                  color: "white",
                  cursor: "pointer",
                  backgroundColor: "#000",
                  opacity: "0.3",
                  padding: "5px 0",
                  fontWeight: "bold",
                  borderRadius: "0.25rem"
                }}
              >
                {/* <Hotkeys keyName="c" onKeyUp={this.topressKey}>
                                    <i className="fas fa-camera" onClick={this.handleStartClick}/></Hotkeys> */}
                {toPress}
              </div>
            </div>
          )}
        </Card>

        <Modal
          isOpen={this.state.previewModal}
          toggle={this.togglePreview}
          className={this.props.className}
          size="lg"
        >
          {/* <Modal isOpen={this.state.previewModal} toggle={this.togglePreview} size="lg"> */}
          <ModalHeader toggle={this.togglePreview}></ModalHeader>
          <ModalBody>
            <img
              src={this.state.previewImage}
              responsive
              alt=""
              style={{
                width: "800px",
                height: "800px"
              }}
            />
          </ModalBody>
        </Modal>
      </Container>
    );
  }

  topressKey() {
    //console.log("==========kEY PRESSED C============"+this.state.cameraActive)
    if (this.state.setHotKeys) {
      // setHotKeys:true
      // this.setState({
      //     ...this.state,
      //     cameraActive:false
      // })
      // this.props.setHotKeys = false;
      this.handleStartClick();
    }
  }
}

export default ImageCaptures;
